/* Supp City v7: duidelijke linkteksten + kortingspercentage in Deals + cadeau-badge + video zonder logo-eind */
(function () {
  function num(t) {
    var m = (t || '').replace(/\./g, '').match(/(\d+),(\d{2})/);
    return m ? parseFloat(m[1] + '.' + m[2]) : NaN;
  }
  /* Deals met een gratis product erbij (geen prijskorting): badge zodat het opvalt */
  var SC_GIFT = {
    'applied-nutrition-cream-of-rice-2000g': '+ Gratis cadeau',
    'applied-nutrition-critical-whey-advanced-protein-2000g': '+ Gratis cadeau',
    'applied-nutrition-critical-mass-lean-mass-gainer-6000g': '+ Gratis cadeau'
  };
  /* Hoofdvideo: het logo-scherm aan het eind (vanaf ~38,6 s) overslaan en direct opnieuw beginnen */
  var SC_VIDEO_END = 38.5;
  function trimVideo() {
    document.querySelectorAll('[id$="__video_banner_QXiA4f"] video, .video-banner video').forEach(function (v) {
      if (v.dataset.scTrim) return;
      v.dataset.scTrim = '1';
      v.addEventListener('timeupdate', function () {
        if (v.currentTime >= SC_VIDEO_END) { v.currentTime = 0; v.play && v.play().catch(function () {}); }
      });
      v.addEventListener('ended', function () { v.currentTime = 0; v.play && v.play().catch(function () {}); });
    });
  }
  function giftBadges() {
    document.querySelectorAll('.card-wrapper').forEach(function (cw) {
      if (cw.querySelector('.sc-gift')) return;
      var a = cw.querySelector('a[href*="/products/"]');
      if (!a) return;
      var h = (a.getAttribute('href') || '').split('/products/')[1];
      h = h ? h.split(/[?#]/)[0] : '';
      if (!SC_GIFT[h]) return;
      var host = cw.querySelector('.card__inner') || cw;
      var b = document.createElement('span');
      b.className = 'sc-gift';
      b.textContent = SC_GIFT[h];
      host.appendChild(b);
    });
  }
  function run() {
    trimVideo();
    giftBadges();
    var map = {
      '/collections/proteine': 'Alle eiwitten',
      '/collections/mega-deals': 'Alle deals',
      '/blogs/de-kennis-kluis': 'Alle artikelen'
    };
    document.querySelectorAll('.collection__view-all a, .blog__view-all a, .title-wrapper-with-link a').forEach(function (a) {
      var p = (a.getAttribute('href') || '').split('?')[0];
      if (map[p]) a.textContent = map[p];
    });
    document.querySelectorAll('[id$="__fc_deals"] .grid__item').forEach(function (li) {
      var sale = li.querySelector('.price--on-sale .price-item--sale');
      var reg = li.querySelector('.price--on-sale s.price-item--regular, .price--on-sale s .price-item--regular');
      if (!sale || !reg) return;
      var s = num(sale.textContent), r = num(reg.textContent);
      if (!(s > 0 && r > s)) return;
      var pct = Math.round((1 - s / r) * 100);
      if (pct < 1) return;
      li.querySelectorAll('.badge').forEach(function (b) { b.textContent = '-' + pct + '%'; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', trimVideo);
})();
